import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import { IFrotaModel } from 'src/app/frota/model/frota.model';
import { AuthenticationService } from '../../services/authentication.service';
import { LoginModel } from 'src/app/model/login.model';
import { TipoEntidades } from 'src/app/subFrota/model/TipoEntidades';
import { IVeiculoModel } from 'src/app/veiculo/model/veiculo.model';
import { IMotoristaModel } from 'src/app/motorista/model/motorista.model';
import { IFiltroRegistroTransacoesViewModel } from 'src/app/relatorios/model/filtro-transacoes-view-model';
import { DatePipe } from '@angular/common';
import { ISubFrotaModel } from 'src/app/subFrota/model/subFrota.model';


@Component({
  selector: 'app-filtro',
  templateUrl: './filtro.component.html',
  styleUrls: ['./filtro.component.scss'],
  providers: [DatePipe]
})

export class FiltroComponent implements OnInit {
  @Input() parent!: any;  

  @Input() inputShowStatusTransacao: boolean = true;
  @Input() inputStatusTransacao: any;
  @Input() showFilterVehicle: boolean = true;
  @Input() showFilterDriver: boolean = true;
  @Input() showDownloadRelatory: boolean = true;

  @Output() onFiltroSelected = new EventEmitter<IFiltroRegistroTransacoesViewModel | null>();
  @Output() onFiltroInit = new EventEmitter<IFiltroRegistroTransacoesViewModel | null>();


  public usuario !: LoginModel;
  tipoEntidades = TipoEntidades;

  public DIAS_PARA_RANGE_DO_PERIODO = 7;
  isCollapsed!: boolean;  
    
  public filtro!: IFiltroRegistroTransacoesViewModel;
  codigoSubFrota!: any;
  codigoFrota!: any;
  codigoVeiculo!: any;
  codigoMotorista!: any;
  statusTransacao = "Todos"
  exportExcel:boolean = false;

  today = new Date();
  ontem = new Date(new Date().setDate(new Date().getDate() - this.DIAS_PARA_RANGE_DO_PERIODO));

  readonly dataPeriodo = new FormGroup({
    inicio: new FormControl(this.ontem),
    fim: new FormControl(this.today)
  });

  constructor(
    private authenticationService: AuthenticationService, 
    private datePipe: DatePipe) { }

  ngOnInit(): void {
    if(this.inputStatusTransacao){
      this.statusTransacao = this.inputStatusTransacao;
    }
    this.usuario = this.authenticationService.getDadosUserLocal();
    this.filtro = { guid: this.usuario.retorno.guid };
    
    this.montarFiltro();   

    this.onFiltroInit?.emit(this.filtro);
  }
  
  onSubmit() {
    this.montarFiltro();    
    this.onFiltroSelected.emit(this.filtro);
  }

  public montarFiltro(){
    this.filtro.datIniPeriodo = this.datePipe.transform(this.dataPeriodo.get("inicio")?.value, 'yyyy-MM-dd')!;
    this.filtro.datFimPeriodo = this.datePipe.transform(this.dataPeriodo.get("fim")?.value, 'yyyy-MM-dd')!;

    this.filtro.status = this.statusTransacao;

    if (this.usuario.retorno.tipo == this.tipoEntidades.frota)
      this.filtro.codFrota = this.usuario.retorno.codigoEntidade;
  }
  
  exportTable(format: string) {
    //, {fileName: getXLSName(), sheet: 'SubFrotas', Props: {Author: 'CTF'}}
    this.parent.exportTable(format);
  }

  selecionaFrota(frota: IFrotaModel | null) {
    if (!frota || !frota.codigo) {
      this.filtro.codFrota = undefined;
    } else {
      this.filtro.codFrota = frota.codigo;
    }
  }

  selecionaSubFrota(subfrota: ISubFrotaModel | null) {
    if (!subfrota || !subfrota.codigo) {
      this.filtro.codSubFrota = undefined;
    } else {
      this.filtro.codSubFrota = subfrota.codigo;
    }
  }

  selecionaVeiculo(veiculo: IVeiculoModel | null) {
    if (!veiculo || !veiculo.codigo) {
      this.filtro.codVeiculo = undefined;
    } else {
      this.filtro.codVeiculo = veiculo.codigo;
    }
  }

  selecionaMotorista(motorista: IMotoristaModel | null) {
    if (!motorista || !motorista.codigo) {
      this.filtro.codMotorista = undefined;
    } else {
      this.filtro.codMotorista = motorista.codigo;
    }
  }  
}